import { useEffect, useState } from 'react'

const KEY = 'sg_hub_handle'

/**
 * The reader's hub handle, learnt once and remembered in this browser per commentHub account, so the
 * header's letter avatar is stable from the first paint after the first visit — instead of "?" while
 * the session loads, then the comment name's initials, then the handle once the menu reads /me
 * (Directive a8b375cd keeps /me lazy). A different account id ignores and replaces the stored value.
 */
export function useRememberedHubHandle(
  readerId: string | null,
  liveHandle: string | null
): string | null {
  const [remembered, setRemembered] = useState<string | null>(null)

  useEffect(() => {
    if (!readerId) {
      return
    }
    try {
      const stored = JSON.parse(window.localStorage.getItem(KEY) ?? 'null') as {
        id?: string
        handle?: string
      } | null
      setRemembered(
        stored?.id === readerId && typeof stored.handle === 'string' ? stored.handle : null
      )
    } catch {
      setRemembered(null)
    }
  }, [readerId])

  useEffect(() => {
    if (!readerId || !liveHandle) {
      return
    }
    setRemembered(liveHandle)
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ id: readerId, handle: liveHandle }))
    } catch {
      // storage blocked: the live handle still shows for this visit
    }
  }, [readerId, liveHandle])

  return liveHandle ?? remembered
}
